export default [
    /**
     *问答
    */
    {
        path: '/ask',
        name: '学习问答',
        component: r => require.ensure([], () => r(require('@/views/ask/index')), 'user')
    },
    {
        path: '/ask/details',
        name: '问答详情',
        component: r => require.ensure([], () => r(require('@/views/ask/details')), 'user')
    },
    {
        path: '/ask/add',
        name: '提问',
        component: r => require.ensure([], () => r(require('@/views/ask/add')), 'user')
    }

]


// WEBPACK FOOTER //
// ./src/router/routers/ask.js